

export type Billing = {
  id: string;
  orderType: string;
  lookupType: string;
  includedQuantity: number;
  unitPrice: number | string;
  cap: number;
  overagePrice: number | string;
  overageType: string;
  overageRanges: OverageRange[];
};
export type OverageRange = {
  startRange: number;
  endRange: number | string;
  overagePrice: number | string;
};
export const getDefaultBilling = (): Billing => ({
  id: "",
  orderType: "Explore",
  lookupType: "",
  includedQuantity: 0,
  unitPrice: 0,
  cap: 0,
  overagePrice: 0,
  overageType: "",
  overageRanges: [
    {
      startRange: 0,
      endRange: 0,
      overagePrice: ""
    }
  ]
});
